import { IconCtaColoredBox } from '@ahc-digital/component-library';
import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { CreateIconCTAColoredBoxModel } from './C32IconCTAColoredBox.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import {
  RenderingProps,
  DynamicPlaceholderParams,
  TranslationOptionsParams,
  AnchorTargetParams,
} from 'src/shared/shared.types';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type C32IconCTAColoredBoxProps = RenderingProps<
  C32IconCTAColoredBoxFields,
  {
    TitleType?: string;
    TitleAlignment?: string;
    SupportCopyAlignment?: string;
    NumberOfColumns?: string;
  } & DynamicPlaceholderParams &
    TranslationOptionsParams &
    AnchorTargetParams
>;

export type C32IconCTAColoredBoxFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  BottomSupportCopy?: RichTextField;
};

export const Default = (props?: C32IconCTAColoredBoxProps) => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <IconCtaColoredBox
      {...CreateIconCTAColoredBoxModel(props)}
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
    />
  );
};
